import { render, staticRenderFns } from "./organizers.html?vue&type=template&id=71dd7bb1&scoped=true&"
import script from "./organizers.js?vue&type=script&lang=js&"
export * from "./organizers.js?vue&type=script&lang=js&"
import style0 from "./organizers.scss?vue&type=style&index=0&id=71dd7bb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd7bb1",
  null
  
)

export default component.exports